import { Address } from '@app/types';

export function getFullAddressText(address: Address) {
  const complementText = address.complement ? `, ${address.complement}` : '';
  const landmarkText = address?.landmark ? `, ${address.landmark}` : '';
  return `${address.street || ''}, ${address.number || ''}${complementText}${landmarkText} - ${
    address.neighborhood || ''
  }, ${address.city.Nom_Cidade || ''}, ${address.city.Sigla_UF || ''}`;
}
